import { NgModule } from '@angular/core';
import { SupplementHashAnchorsPipe } from './supplement-hash-anchors.pipe';

@NgModule({
  declarations: [SupplementHashAnchorsPipe],
  exports: [SupplementHashAnchorsPipe],
})
export class SupplementHashAnchorsModule {}
